const items = [
  {
    icon: "ri-sofa-line",
    title: "家具・インテリア",
    text: "ソファ・ベッド・タンス・机・椅子・マットレスなど。大型家具もスタッフが丁寧に搬出します。",
  },
  {
    icon: "ri-fridge-line",
    title: "家電（家電リサイクル対象品含む）",
    text: "冷蔵庫・洗濯機・テレビ・エアコンなど。家電リサイクル法に基づき適正に回収・処分します。",
  },
  {
    icon: "ri-truck-line",
    title: "大型ゴミ・粗大ゴミ",
    text: "京都市の粗大ゴミ受付では回収しきれないもの、まとめて処分したいものを一括で回収します。大型の粗大ゴミ処分もお任せください。",
  },
  {
    icon: "ri-home-smile-2-line",
    title: "引越し一括・お部屋まるごと",
    text: "引越しで出た大量の不用品、ご実家の片付け、退去時の残置物などをお部屋ごとスッキリ回収します。",
  },
];

export default function Items() {
  return (
    <section id="items" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            ITEMS
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            回収できる
            <span className="text-primary-500">不用品・対応品目</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            家具・家電・大型ゴミからお部屋まるごとの片付けまで、幅広い不用品に対応しています。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((it) => (
            <div
              key={it.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 mb-5">
                <i className={`${it.icon} text-secondary-700 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {it.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}